import styled from 'styled-components';
import useInsightsSetting from '../../../Insights/useInsights/useInsightsSetting';
import { extractInsightsByKeysFromSetting } from '../../../Insights/useInsights/insights.formatters';
import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import { lightColorPalette } from '@linearb/linui-common';
import { mapInsightToChipTitle } from '../../../Insights/insights.view';
import { capitalize } from 'lodash';
import usePmProvider from 'components/hooks/PM/usePmProvider';

const StyledInsightFilterIndicator = styled.div`
  margin-left: 0.5rem;
  display: flex;
  align-items: center;

  & .MuiChip-root {
    height: 2.6rem;

    & .MuiChip-label {
      font-size: 1rem;
    }
    & svg#close {
      width: 1.2rem;
      color: ${lightColorPalette.lbBlue_60};
    }
  }
`;

const InsightFilterIndicator = ({ insightKey, onRemove }) => {
  const pmProvider = usePmProvider();
  const insightSetting = useInsightsSetting();
  const insightSettingByKeys = useMemo(
    () => extractInsightsByKeysFromSetting(insightSetting.value),
    [insightSetting.value]
  );
  const insight = insightSettingByKeys[insightKey];

  const filterTitle = capitalize(
    mapInsightToChipTitle({ insight, pmProvider })
  );

  return (
    <StyledInsightFilterIndicator>
      <Chip
        label={filterTitle}
        variant='outlined'
        deleteIcon={<Icon name='close' />}
        onDelete={onRemove}
      />
    </StyledInsightFilterIndicator>
  );
};

export default InsightFilterIndicator;
